import PlansSeeds from './plans'
import SitesSeeds from './sites'

export default (server) => {
  PlansSeeds(server)
  SitesSeeds(server)
}
